import React, { useEffect, useState } from 'react';
import { Box, Stack } from '@mui/material';
import { LenderPerformanceReportInput } from '@trnsact/trnsact-shared-types';
import { useLenderPerformanceConversionFunnel } from '../../../../hooks/useLenderPerformanceConversionFunnel';
import { CONVERSION_TABLE_DEFAULT_SORTING } from '../../../../constants';
import { ConversionTableSorting } from '../../../../types';
import { KeyRatioCards } from './KeyRatioCards';
import { PipelineFunnelCard } from './PipelineFunnelCard';
import { LenderConversionTable } from './LenderConversionTable';
import { LookToBookByLenderChart } from './LookToBookByLenderChart';
import { MonthlyLookToBookChart } from './MonthlyLookToBookChart';

interface Props {
  input: LenderPerformanceReportInput;
  onLoadingChange?: (isLoading: boolean) => void;
}

export const ConversionFunnel = ({ input, onLoadingChange }: Props) => {
  const [sorting, setSorting] = useState<ConversionTableSorting>(CONVERSION_TABLE_DEFAULT_SORTING);

  const {
    ratioCards,
    funnel,
    conversionTable,
    trend,
    isRatioCardsLoading,
    isFunnelLoading,
    isConversionTableLoading,
    isTrendLoading,
  } = useLenderPerformanceConversionFunnel(input, sorting);

  const isLoading = isRatioCardsLoading || isFunnelLoading || isConversionTableLoading || isTrendLoading;

  useEffect(() => {
    onLoadingChange?.(isLoading);
  }, [isLoading, onLoadingChange]);

  return (
    <Stack gap="0.5rem">
      <KeyRatioCards ratioCards={ratioCards} filters={input.filters} loading={isRatioCardsLoading} />

      <PipelineFunnelCard funnel={funnel} loading={isFunnelLoading} />

      <Box data-pdf-page-break>
        <LenderConversionTable
          rows={conversionTable}
          loading={isConversionTableLoading}
          sorting={sorting}
          onSortingChange={setSorting}
        />
      </Box>

      <Box data-pdf-no-break>
        <LookToBookByLenderChart rows={conversionTable} filters={input.filters} loading={isConversionTableLoading} />
      </Box>

      <Box data-pdf-no-break>
        <MonthlyLookToBookChart rows={trend} loading={isTrendLoading} />
      </Box>
    </Stack>
  );
};
